















import Vue from "vue";
import CategoryActions from "@/views/dashboard/CategoryActions.vue";

export default Vue.extend({
  components: {
    CategoryActions
  },
  computed: {
    onMobile() {
      return this.$route.meta.fullOnMobile;
    }
  }
});
